/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Detecting_TextInputs */



/**
* | output |
* | --- |
* | "Detecting shot changes..." |
*
* @param {Scene_Change_Detection_Detecting_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_detecting_text = /** @type {((inputs?: Scene_Change_Detection_Detecting_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Detecting_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Detection des changements de plan...")
	if (locale === "de") return /** @type {LocalizedString} */ ("Erkennung von Szenenwechseln...")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rilevamento dei cambiamenti di tiro...")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Обнаружение изменений в кадре...")
	if (locale === "es") return /** @type {LocalizedString} */ ("Detectando cambios de toma...")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("检测投篮变化……")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ショットの変更を検出しています...")
	if (locale === "hi") return /** @type {LocalizedString} */ ("शॉट में बदलाव का पता लगाना...")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Detectando mudanças de tiro...")
	return /** @type {LocalizedString} */ ("Detecting shot changes...")
});